import { defineStore } from 'pinia'
import { useConfigStore } from '@dashboard/stores/configStore'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

export const useTagStore = defineStore('tag', () => {
  const configStore = useConfigStore()
  const { config } = storeToRefs(configStore)

  const tags = computed(() => config.value?.tags || [])

  const getById = (id: string) => tags.value.find((tag) => tag.id === id)

  return {
    tags,
    getById
  }
})
